<template>
  <div class="header">
    <!-- <p class="title">农产品溯源中心</p> -->
    <div class="company">
      <img class="company-logo" :src="'https://yuan.znstny.cn/' + logo" alt="" v-if="logo" />
      <img class="company-logo" src="../../static/images/logo.png" alt="" v-if="!logo" />
      <p class="company-name">{{ store_name }}</p>
    </div>
    <div class="btn">
      <router-link to="/login/editpassword">修改密码</router-link>
      <router-link to="/companiesintro">企业介绍</router-link>
      <router-link to="/applyforrecord">申请记录</router-link>
      <a @click="loginOut">退出登录</a>
    </div>
  </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui';
export default {
  data() {
    return {};
  },
  props: ['store_name', 'logo'],
  methods: {
    loginOut() {
      MessageBox.confirm('是否退出？', '提示').then(action => {
        this.$request.post(
          '/front/Login/frontlogout',
          {
            id: window.localStorage.getItem('store_id'),
            token: window.localStorage.getItem('token')
          },
          res => {
            if (res.status == 1) {
              setTimeout(() => {
                this.$router.push('/login');
              }, 1200);
              window.localStorage.clear();
            } else {
              Toast(res.msg);
            }
          }
        );
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  border: 1px solid transparent;
  width: 100%;
  height: auto;
  background: #299e72;
  color: #ffffff;
  padding: 0.3rem;
  .title {
    text-align: center;
    margin-top: 0.6rem;
    font-size: 0.4rem;
  }
  .company {
    // margin-top: 0.6rem;
    .company-logo {
      display: block;
      margin: 0 auto;
      width: 1.4rem;
      height: 1.4rem;
      border-radius: 50%;
    }
    .company-name {
      text-align: center;
      font-size: 0.32rem;
      font-weight: bold;
      margin-top: 0.2rem;
      margin-bottom: 0.4rem;
    }
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 0.5rem;
    a {
      display: block;
      width: 1.6rem;
      height: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      opacity: 0.8;
      border-radius: 0.25rem;
      color: #299e72;
      margin-left: 7px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/companyBar.vue